import React from 'react';
import Link from 'next/link';
import DefaultMenu from '../../elements/menu/DefaultMenu';
import menuData from '~/public/static/data/menu';
import CurrencyDropdown from '../headers/modules/CurrencyDropdown';
import LanguageSwicher from '../headers/modules/LanguageSwicher';
import MenuCategoriesDropdown from '~/components/shared/menus/MenuCategoriesDropdown';

export default function DesktopNavigation() {
    return (
        <nav className="navigation">
            <div className="ps-container">
                <div className="navigation__left">
                    <MenuCategoriesDropdown />
                </div>
                <div className="navigation__right">
                    <DefaultMenu
                        className="menu"
                    />
                    <ul className="navigation__extra">
                        <li>
                            <Link href={'/business/become-a-vendor'}>
                                Verkaufen auf Rawento
                            </Link>
                        </li>
                        <li>
                            <Link href={'/account/order-tracking'}>
                                Bestellung verfolgen
                            </Link>
                        </li>
                        {/* <li>
                            <CurrencyDropdown />
                        </li>
                        <li>
                            <LanguageSwicher />
                        </li> */}
                    </ul>
                </div>
            </div>
        </nav>
    );
}
